<template>

  <div class="account-page" :class="{active: active}" :data-account-page="id">

    <div class="tabbed">

      <div class="tab-header">

        <internal-nav class="tabs" :active-item="activeSubpage" :items="navItems" @select="changePage"></internal-nav>

        <div class="table-actions mobile-break">
          <div class="action">
            <button type="button" class="rounded small" :class="{current: mode === 'grid'}" @click="mode = 'grid'">
              Grid
            </button>
          </div>
          <div class="action">
            <button type="button" class="rounded small" :class="{current: mode === 'list'}" @click="mode = 'list'">
              List
            </button>
          </div>
        </div>

      </div>
      <!-- /.tab-header -->

      <div class="content-panes view-switchable" :class="['mode-' + mode]" v-if="active || wasActive">

        <div id="bookings-in-review" class="content-pane" :class="{active: (activeSubpage === 'index')}">
          <div class="view view-list" :class="{active: isListView}">
            <account-table data-url="/api/account/listings/in-review" table-class="listings-listing"
                           :columns="listingTableColumns" @action="doListingAction"
                           v-if="isActivatedSubpage('index')"></account-table>
          </div>
          <div class="view view-grid" :class="{active: isGridView}">
            <listing type="listing-item" data-url="/api/account/listings/in-review" tag="ul"
                     :listing-classes="['listing', 'search-results']" @action="doListingAction"
                     v-if="isActivatedSubpage('index')"></listing>
          </div>
        </div>

        <div id="bookings-active" class="content-pane" :class="{active: (activeSubpage === 'active')}">
          <div class="view view-list" :class="{active: isListView}">
            <account-table data-url="/api/account/listings" table-class="listings-listing"
                           :columns="listingTableColumns" @action="doListingAction"
                           v-if="isActivatedSubpage('active')"></account-table>
          </div>
          <div class="view view-grid" :class="{active: isGridView}">
            <listing type="listing-item" data-url="/api/account/listings" tag="ul"
                     :listing-classes="['listing', 'search-results']" @action="doListingAction"
                     v-if="isActivatedSubpage('active')"></listing>
          </div>
        </div>

        <div id="bookings-rejected" class="content-pane" :class="{active: (activeSubpage === 'rejected')}">
          <div class="view view-list" :class="{active: isListView}">
            <account-table data-url="/api/account/listings/rejected" table-class="listings-listing"
                           :columns="listingTableColumns" @action="doListingAction"
                           v-if="isActivatedSubpage('rejected')"></account-table>
          </div>
          <div class="view view-grid" :class="{active: isGridView}">
            <listing type="listing-item" data-url="/api/account/listings/rejected" tag="ul"
                     :listing-classes="['listing', 'search-results']" @action="doListingAction"
                     v-if="isActivatedSubpage('rejected')"></listing>
          </div>
        </div>

      </div>
      <!-- /.content-panes -->

    </div>
    <!-- /.tabbed -->

  </div>

</template>

<script>
import Vue from 'vue'
import ListingItem from './elements/Listing'
import AccountSubpage from '../../../AccountSubpage'

Vue.component('listing-item', ListingItem)

export default {
  extends: AccountSubpage,

  data () {
    return {
      id: 'listings',
      mode: (localStorage['listingsViewMode']) ? localStorage['listingsViewMode'] : 'grid',
    }
  },

  computed: {

    isGridView () {
      return (this.mode === 'grid')
    },

    isListView () {
      return (this.mode === 'list')
    },

    listingTableColumns () {
      return [
        { id: 'number', type: 'rowCount', label: '#' },
        { id: 'id', type: 'string', label: 'Property ID' },
        { id: 'space_name', type: 'string', label: 'Listing name' },
        { id: 'address_label', type: 'string', label: 'Listing address' },
        { id: 'updated_at', type: 'date', label: 'Date modified' },
      ]
    },

    navItems () {
      return [
        { id: 'index', label: 'In Review' },
        { id: 'active', label: 'Active' },
        { id: 'rejected', label: 'Rejected' }
      ]
    },

  },

  watch: {
    mode () {
      localStorage['listingsViewMode'] = this.mode
    },
  },

  created () {
  },

  mounted () {
  },

  methods: {

    doListingAction (e) {

      switch (e.action) {
        case 'edit':
          this.$store.dispatch('modals/showAddListing', {
            edit: e.record.id || null
          })
              .catch(() => {})
          break
      }
    },

  }
}
</script>
